export async function fetchTonTestnet(address) {
    const url = `https://testnet.toncenter.com/api/v3/actions?account=${address}&limit=20&sort=desc`;
    const res = await fetch(url);
    if (!res.ok) {
        return [];
    }
    const data = await res.json();
    const acts = Array.isArray(data?.actions) ? data.actions : [];
    return acts
        .map(a => ({
            timeSec: Number(a.end_utime || a.start_utime || Date.now() / 1000),
            valueRaw: String(a?.details?.value ?? '0'),
            from: a?.details?.source || 'unknown',
            to: a?.details?.destination || 'unknown',
            network: 'TON Testnet',
            meta: {},
        }))
        .filter(t => t.from !== 'unknown' && t.to !== 'unknown');
}
